import {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {showResponsiveMenu} from '../../actions/common/index';

class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        // var scale = 'scale(1)';
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
            // this.zoomOutMobile();
            this.props.showResponsiveMenu(false);
        }
        
    }

    zoomOutMobile() {
        var viewport = document.querySelector('meta[name="viewport"]');
        if ( viewport ) {
            viewport.content = "initial-scale=0.1";
            viewport.content = "width=1200";
        }
    }

    render() {
        return this.props.children;
    }
}

function mapStateToProps(state) {
    return {
        
    }
}

export default withRouter(connect(mapStateToProps, {showResponsiveMenu})(ScrollToTop));